import React, { useState, useEffect } from 'react';
import { Card, CardContent, Grid,Typography, TextField, Select, MenuItem, Checkbox, Radio, FormControlLabel, Button, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccountCircle, Email, Phone, Add,Remove,LocationOn, VerifiedUserOutlined, Lock, DateRange, FormatListNumbered, Person } from '@mui/icons-material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import { COLORS } from '../colors';
import api from '../../Services/api';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link ,useNavigate} from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import Autorenew from '@mui/icons-material/Autorenew';



const useStyles = makeStyles({
 

  detail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    
    marginTop:15,
 
    
  },
  
  textField: {
    width: '80%',
    '& .MuiInputLabel-root': {
      color: 'gray', // Default label color (or set to something else)
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'gray', // Outline color to white when not focused
      },
      '&:hover fieldset': {
        borderColor: 'gray', // Optional: Outline color on hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black', // Optional: Outline color when focused
      },
      
      
    },
   
    // When the field is focused, change label color to white
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'gray',
    },
    // Text inside input area when focused
    '& .MuiOutlinedInput-input': {
      color: 'black', // Text color inside the input area when focused
    },
    // Ensure the text inside is visible when the field is not focused
    '& .MuiOutlinedInput-input.Mui-focused': {
      color: 'black', // Make text black when focused to keep it visible
    },
  },
  
  
});

const statesInIndia = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Ladakh', 'Lakshadweep', 'Puducherry'];
const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);

const CompanyCard = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    CorporateId: '',
    principleEmployer: '',
    stateId: '',
    placeName: '',
    pinCode:'',
    companyAddress: '',
    authorisedPersonName: '',
    companyEmailId: '',
    companyEmailId1: '',
    companyPhoneNumber: '',
    companyPhoneNumber1: '',
    clientName: '',
    clientAddress:'',
    division:'',
    clientContactPersonName: '',
    clientContactPersonPhoneNumber: '',
    clientContactPersonPhoneNumber1: '',
    clientContactPersonEmailId: '',
    clientContactPersonEmailId1: '',
    isClient: true,
    clientUsername: '',
    clientPassword: '',
    startDate: '',
    endDate: '',

  });
  const navigate=useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const [errors, setErrors] = useState({});
  const[corporate,setCorporate] = useState([]);
  
  const [extraEmailCompanyVisible, setExtraEmailCompanyVisible] = useState(false);
  const [extraPhoneNumberCompanyVisible, setExtraPhoneNumberCompanyVisible] = useState(false);
  const [extraEmailClientVisible, setExtraEmailClientVisible] = useState(false);
  const [extraPhoneNumberClientVisible, setExtraPhoneNumberClientVisible] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');

const generatePassword = ( length = 12 ) => {
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number = '0123456789';
  const special = '!@#$%^&*()_+[]{}|;:,.<>?';
  const all = lower + upper + number + special;

  if (length < 8) throw new Error("Password length must be at least 8");

  const getRandomChar = (charset) =>
    charset.charAt(Math.floor(Math.random() * charset.length));

  // Ensure at least one from each required set
  let password = [
    getRandomChar(lower),
    getRandomChar(upper),
    getRandomChar(number),
    getRandomChar(special)
  ];

  // Fill the rest with random characters from all allowed sets
  for (let i = password.length; i < length; i++) {
    password.push(getRandomChar(all));
  }

  // Shuffle the result to avoid predictable order
  return password
    .sort(() => 0.5 - Math.random())
    .join('');
};


const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    handleChange({ target: { name: 'clientPassword', value: newPassword } });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleAddEmailCompanyField = () => {
    setExtraEmailCompanyVisible(prevState => !prevState);
  };

  const handleAddPhoneNumberCompanyField = () => {
    setExtraPhoneNumberCompanyVisible(prevState =>!prevState);
  };
  const handleAddEmailClientField = () => {
    setExtraEmailClientVisible(prevState=> !prevState);
  };

  const handleAddPhoneNumberClientField = () => {
    setExtraPhoneNumberClientVisible(prevState =>!prevState);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
    const error = validateField(name, value);
    setErrors(prev => ({
      ...prev,
      [name]: error,
    }));
  };

  //VALIDATION
  const validateField = (name, value) => {
    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
    const phonePattern = /^[6-9]\d{9}$/;
    const pinCodePattern = /^(?!000000$)[0-9]{6}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;
   const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    switch (name) {
      case 'principleEmployer':
        return value.trim() ? '' : 'Company Name is required';
  
      case 'stateId':
        return value ? '' : 'State is required';
  
      case 'placeName':
        return value.trim() ? '' : 'Place / City is required';
  
      case 'companyAddress':
        return value.trim() ? '' : 'Address is required';
  
      case 'authorisedPersonName':
        return value.trim() ? '' : 'Contact Person Name is required';
  
      case 'companyEmailId':
        if (!value) return 'Email address is required';
        return emailPattern.test(value) ? '' : 'Invalid email address (e.g., text@email.com)';
  
      case 'companyEmailId1':
        return value && !emailPattern.test(value) ? 'Invalid email address (e.g., text@email.com)' : '';
  
      case 'companyPhoneNumber':
        if (!value) return 'Contact number is required';
        if (!phonePattern.test(value)) return 'Invalid contact number, should start with 6-9 and length should be 10 digits';

        return '';
  
      case 'companyPhoneNumber1':
        return value && !phonePattern.test(value) ? 'Invalid contact number, should start with 6-9 and length should be 10 digits' : '';
  
      case 'pinCode':
        if (!value) return 'Pin code is required';
        return pinCodePattern.test(value) ? '' : 'Invalid Pin code format (e.g., 560001)';
  
      case 'clientName':
        return value.trim() ? '' : 'Establishment Name is required';
        case 'clientAddress':
        return value.trim() ? '' : 'Establishment Address is required';
   case 'division':
        return value.trim() ? '' : 'Division is required';
  
      case 'clientContactPersonName':
        return value.trim() ? '' : 'Contact Person Name is required';
  
      case 'clientContactPersonEmailId':
        if (!value) return 'Email address is required';
        return emailPattern.test(value) ? '' : 'Invalid email address (e.g., text@email.com)';
  
      case 'clientContactPersonEmailId1':
        return value && !emailPattern.test(value) ? 'Invalid email address (e.g., text@email.com)' : '';
  
      case 'clientContactPersonPhoneNumber':
        if (!value) return 'Contact number is required';
        if (!phonePattern.test(value)) return 'Invalid contact number, should start with 6-9 and length should be 10 digits';

        return '';
  
      case 'clientContactPersonPhoneNumber1':
        return value && !phonePattern.test(value) ? 'Invalid contact number, should start with 6-9 and length should be 10 digits' : '';
  
      case 'startDate':

       if (!value) return 'Contract Start Date is required';
        if (!dateRegex.test(value)) return 'Invalid date format';

        return '';

      
      case 'endDate':
         if (!value) return 'Contract End Date is required';
        if (!dateRegex.test(value)) return 'Invalid date format';

        return '';
  
      case 'clientUsername':
        return value.trim() ? '' : 'Username is required';
  
      case 'clientPassword':
        if (!value) return 'Password is required';
        return passwordRegex.test(value)
          ? ''
          : 'Password must be 8–12 characters long, include uppercase, lowercase, number, special character, and no spaces';
  
      default:
        return '';
    }
  };
  

  const validateForm = () => {
    const newErrors = {};
  
    Object.keys(formData).forEach((fieldName) => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
        newErrors[fieldName] = error;
      }
    });
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ returns true if no errors
  };
  


useEffect(()=>{
api.Corporate.getCorporate()
.then(response => {
  setCorporate(response.data.data)
})
.catch(error => {
  console.error(`Error fetching Corporate Names`,error)
})
},[])



  //CREATING CLIENT PROFILE
  const handleSave = async () => {
    const isValid = validateForm();
    if (isValid) {
      let data = sessionStorage.getItem('user');
      let data1 = JSON.parse(data);
      let type = data1.type;
     
      try {
        if (type === 'admin'){
       const response =  await api.client.createClient(formData)
          if (response.status === 400) {
            
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message)
          }
         else if (response.status === 201) {
            const clientData = response.data;
            sessionStorage.setItem('client', JSON.stringify(clientData));

            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            
            setFormData({
              CorporateId:'',
              principleEmployer: '',
              stateId: '',
              placeName: '',
              pinCode:'',
              companyAddress: '',
              authorisedPersonName: '',
              companyEmailId: '',
              companyEmailId1: '',
              companyPhoneNumber: '',
              companyPhoneNumber1: '',
              clientName: '',
              clientAddress:'',
              division:'',
              clientContactPersonName: '',
              clientContactPersonPhoneNumber: '',
              clientContactPersonPhoneNumber1: '',
              clientContactPersonEmailId: '',
              clientContactPersonEmailId1: '',
              isClient: true,
              clientUsername: '',
              clientPassword: '',
              startDate: '',
              endDate: '',
            });

            setTimeout(() => {
              handleSubmit();
            },1000);
          }

        
      
       else if (response.status === 500) {
            
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message)
          }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Only admin can create company");
        navigate('/');
            }
    }
    
  }
  
        catch(error) {
          console.error('Error saving company data:', error);
         
          
        }
      }
  }
  


  //CLIENT MASTERDATA CREATION
  const handleSubmit = async() => {
    let data = sessionStorage.getItem('client');
    let clientData = JSON.parse(data);
    const id = clientData.data.companyId;
    const division = clientData.data.division
    const masterData = {
      companyId: id,
      year: currentYear,
      CorporateId: formData.CorporateId,
      AcceptedPercent: 0,
      RejectedPercent: 0,
      division: division,
      UnderReviewPercent: 0,
      complied : 0,
      nonComplied : 0,

    
      GSTCertificate: {
        value: '',
       
    
      },
      TradeLicenceRegAndRenewal: {
        value: '',
      
      },
      FactoryLicence: {
        value: '',
     
      },
      BuildingPlanLayout: {
        value: '',
     
      },
      StabilityCertificate: {
        value: '',
     
      },
      ConcernToEstablishment: {
        value: '',
      
      },
      ConcernToOperations: {
        value: '',
     
      },
      FireAdvisory: {
        value: '',
     
      },
      FireNOC: {
        value: '',
    
      },
      EnvironmentClearance: {
        value: '',
   
      },
      MedicalHospitalCertificate: {
        value: '',
    
      },
      PSARALicence: {
        value: '',
    
      },
      FSSAILicence: {
        value: '',
      
      },
      ManagerChange: {
        value: '',
       
      },
      EPFOAllotmentCopy: {
        value: '',
    
      },
      ESICAllotmentCopy: {
        value: '',
    
      },
      PTaxRCNumber: {
        value: '',
   
      },
      PTECNumber: {
        value: '',
    
      },
      LWFNumber: {
        value: '',
      
      },
      CLRARC: {
        value: '',
     
      },
      SandCERC: {
        value: '',
      
      },
      BOCWRC: {
        value: '',
      
      },
      ISMWRC: {
        value: '',
      
      },
      ApprenticeshipRegistration: {
        value: '',
      
      },
       NEEMNAPSRegistration: {
        value: '',
      
      },
       WCPolicyNumber: {
        value: '',
      
      },
       StandingOrder: {
        value: '',
      
      },
       ShiftApproval: {
        value: '',
      
      },
       DisplayOfNoticeContainingAbstracts: {
        value: '',
      
      },
       HazardouswasteDisposalApproval: {
        value: '',
      
      },
       BiomedicalWasteApproval: {
        value: '',
      
      },
       BoilerAmendment: {
        value: '',
      
      },
       AnalysisFeePayment: {
        value: '',
      
      },
      ComplianceCertificate: {
        value: '',
      },
       ESGPolicy: {
        value: '',
      },
       PolicyOnPOSHAct2013: {
        value: '',
      },
       POSHInternalCommittee: {
        value: '',
      },
         CompanyIncorporationNumber: {
        value: '',
      },
         EnviornmentalPolicy: {
        value: '',
      },
         HumanRightsPolicy: {
        value: '',
      },
         DiversityPolicy: {
        value: '',
      },
         WhistleblowerPolicy: {
        value: '',
      },
         AuditCommittee: {
        value: '',
      },
         NominationAndRemunerationCommittee: {
        value: '',
      },
         CSRCommittee: {
        value: '',
      },
      CSRPolicyAndStrategy: {
        value: '',
      },
         RiskManagementCommittee: {
        value: '',
      },
         SustainabilityCommittee: {
        value: '',
      },
         CodeOfBusinessEthicsAndConduct: {
        value: '',
      },
         PolicyOnRelatedPartyTransactionsDisclosed: {
        value: '',
      },




    }

 try{
    const response = await api.client.createClientMasterData(masterData) 
      if(response.status === 201){
       setTimeout(() => {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message)
       }, 3000);
        
        setFormData({
          CorporateId:'',
          principleEmployer: '',
    stateId: '',
    placeName: '',
    pinCode:'',
    companyAddress: '',
    authorisedPersonName: '',
    companyEmailId: '',
    companyEmailId1: '',
    companyPhoneNumber: '',
    companyPhoneNumber1: '',
    clientName: '',
    clientAddress:'',
    division:'',
    clientContactPersonName: '',
    clientContactPersonPhoneNumber: '',
    clientContactPersonPhoneNumber1: '',
    clientContactPersonEmailId: '',
    clientContactPersonEmailId1: '',
    isClient: true,
    clientUsername: '',
    clientPassword: '',
    startDate: '',
    endDate: '',
        });
      }
      else if(response.status === 400){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
       else if(response.status === 500){
        
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message)
      }
      else{
       
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Some error occured,try again");
        setFormData({
          CorporateId:'',
          principleEmployer: '',
    stateId: '',
    placeName: '',
    pinCode:'',
    companyAddress: '',
    authorisedPersonName: '',
    companyEmailId: '',
    companyEmailId1: '',
    companyPhoneNumber: '',
    companyPhoneNumber1: '',
    clientName: '',
    clientAddress:'',
    division:'',
    clientContactPersonName: '',
    clientContactPersonPhoneNumber: '',
    clientContactPersonPhoneNumber1: '',
    clientContactPersonEmailId: '',
    clientContactPersonEmailId1: '',
    isClient: true,
    clientUsername: '',
    clientPassword: '',
    startDate: '',
    endDate: '',
        });
      }
    
    }
      catch(error) {
        console.error('Error saving company master data:', error);
      
        
      }
  };



  return (
  <>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          
          }}
          severity="success"
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={() => setSnackbarOpen(false)}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="error"
          open={errorSnackbarOpen}
          autoHideDuration={2000}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
          onClose={() => {setErrorSnackbarOpen(false)}}
        >
          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
        </Snackbar>
   <div style={{background:'#eeee'}}>
   <h4 className="p-3  text-center " style={{borderRadius:'0px 0px 0px 0px',background: 'linear-gradient(205deg, rgba(28,28,28,1) 68%, rgba(213,214,215,0) 8%)',color:'#eeee'}}>Create Establishment Profile</h4>
<div className="mt-4">

 

    <Grid container  >

      <Grid item xs={12} sm={6}>
      <h6 className="text-secondary pb-2" style={{paddingLeft:'60px'}}>Client Details</h6>
            <FormControl fullWidth sx={{marginLeft:8,marginTop:2,marginBottom:2}}>
          {/* <LocationOn className={classes.icon} /> */}
                    <InputLabel id="demo-simple-select-label">Select Corporate / Company Name</InputLabel>
          <Select
          // style={{border:'1px solid whitesmoke'}}
            className={classes.textField}
               labelId="demo-simple-select-label"
          id="demo-simple-select"
            label="Select Corporate / Company Name"
            value={formData.CorporateId}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            name="CorporateId"
            displayEmpty
          
          >
          
            {/* <MenuItem value="" disabled>Select Corporate</MenuItem> */}
            {Array.isArray(corporate) && corporate.map((corporate, index) => (
              <MenuItem key={index} value={corporate.CorporateId}>{corporate.CorporateName}, {corporate.CorporateState}</MenuItem>
            ))}
          </Select>
        </FormControl>
       
     
       
       
        <div className={classes.detail}>
      
          {/* <AccountCircle className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Name of the principal Employer"
            name="principleEmployer"
            InputLabelProps={{ shrink: true }}
            value={formData.principleEmployer}
            onChange={handleChange}
            error={!!errors.principleEmployer}
            helperText={errors.principleEmployer}
           
           
          />
        </div>
       
        <FormControl fullWidth sx={{marginLeft:8,marginTop:2,marginBottom:2}}>

<InputLabel id="demo-simple-select-label">Select State</InputLabel>
          <Select
          // style={{border:'1px solid whitesmoke'}}
            className={classes.textField}
            labelId="demo-simple-select-label"
       id="demo-simple-select"
           label="Select State"
            value={formData.stateId}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            name="stateId"
            displayEmpty
            error={!!errors.stateId}
          >
          
            {/* <MenuItem value="" disabled>Select State</MenuItem> */}
            {statesInIndia.map((state, index) => (
              <MenuItem key={index} value={state}>{state}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {errors.stateId && (
            <div className="pb-2  text-center" style={{ color: 'red', fontSize: '14px' }}>
              {errors.stateId}
            </div>
          )}
        <div className={classes.detail}>
          {/* <MyLocationIcon className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Place / City"
            name="placeName"
            value={formData.placeName}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            error={!!errors.placeName}
            helperText={errors.placeName}
          />
        </div>

        <div className={classes.detail}>
          {/* <LocationOn className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Address"
            name="companyAddress"
            InputLabelProps={{ shrink: true }}
            value={formData.companyAddress}
            onChange={handleChange}
            error={!!errors.companyAddress}
            helperText={errors.companyAddress}
          />
        </div>

        <div className={classes.detail}>
          {/* <LocationOn className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Pincode"
            name="pinCode"
            InputLabelProps={{ shrink: true }}
            value={formData.pinCode}
            onChange={handleChange}
            error={!!errors.pinCode}
            helperText={errors.pinCode}
          />
        </div>

        <div className={classes.detail}>
          {/* <AccountCircle className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Authorised Name"
            name="authorisedPersonName"
            InputLabelProps={{ shrink: true }}
            value={formData.authorisedPersonName}
            onChange={handleChange}
            error={!!errors.authorisedPersonName}
            helperText={errors.authorisedPersonName}
          />
        </div>

        <div className={classes.detail}>
          {/* <Phone className={classes.icon} /> */}
          <TextField
              sx={{ marginLeft: '42px' }}
              className={classes.textField}
              label="Contact Number"
              name="companyPhoneNumber"
              InputLabelProps={{ shrink: true }}
              value={formData.companyPhoneNumber}
              onChange={handleChange}
              error={!!errors.companyPhoneNumber}
              helperText={errors.companyPhoneNumber}
          />
          
          <IconButton onClick={handleAddPhoneNumberClientField} style={{ marginLeft: '5px' }} color="primary">
              {extraPhoneNumberClientVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
          </IconButton>
      </div>

      {extraPhoneNumberClientVisible && (
          <div className={classes.detail}>
            {/* <PhoneIphoneIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
             
              label="Alternative Contact Number"
              name="companyPhoneNumber1"
              InputLabelProps={{ shrink: true }}
              value={formData.companyPhoneNumber1}
              onChange={handleChange}
              error={!!errors.companyPhoneNumber1}
              helperText={errors.companyPhoneNumber1}
            />
          </div>
        )}

        <div className={classes.detail}>
          {/* <Email className={classes.icon} /> */}
          <TextField
          sx={{marginLeft:'42px'}}
            className={classes.textField}
            label="Email"
            InputLabelProps={{ shrink: true }}
            name="companyEmailId"
            value={formData.companyEmailId}
            onChange={handleChange}
            error={!!errors.companyEmailId}
            helperText={errors.companyEmailId}
          />
         <IconButton onClick={handleAddEmailClientField} style={{ marginLeft: '5px' }} color="primary">
              {extraEmailClientVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
          </IconButton> 
        </div>

        {extraEmailClientVisible && (
          <div className={classes.detail}>
            {/* <MailOutlineIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              type="email"
              label="Alternative Email"
              name="companyEmailId1"
              InputLabelProps={{ shrink: true }}
              value={formData.companyEmailId1}
              onChange={handleChange}
              error={!!errors.companyEmailId1}
              helperText={errors.companyEmailId1}
            />
          </div>
        )}

      </Grid>

      {/* Contractor Details Column */}
      <Grid item xs={12} sm={6}  >
      <h6 className="text-secondary pb-2" style={{paddingLeft:'60px'}}>Establishment Details</h6>
        <div className={classes.detail}>
          {/* <Person className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Establishment / Company Name"
            name="clientName"
            InputLabelProps={{ shrink: true }}
            value={formData.clientName}
            onChange={handleChange}
            error={!!errors.clientName}
            helperText={errors.clientName}
          />
        </div>

        <div className={classes.detail}>
          {/* <Person className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Address"
            name="clientAddress"
            InputLabelProps={{ shrink: true }}
            value={formData.clientAddress}
            onChange={handleChange}
            error={!!errors.clientAddress}
            helperText={errors.clientAddress}
          />
        </div>
         <div className={classes.detail}>
          {/* <Person className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Division"
            name="division"
            InputLabelProps={{ shrink: true }}
            value={formData.division}
            onChange={handleChange}
            error={!!errors.division}
            helperText={errors.division}
          />
        </div>

        <div className={classes.detail}>
          {/* <Person className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Authorised Name"
            name="clientContactPersonName"
            value={formData.clientContactPersonName}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            error={!!errors.clientContactPersonName}
            helperText={errors.clientContactPersonName}
          />
        </div>

        <div className={classes.detail}>
          {/* <Phone className={classes.icon} /> */}
          <TextField
          sx={{marginLeft:'42px'}}
            className={classes.textField}
            label="Contact Number"
        
            InputLabelProps={{ shrink: true }}
            name="clientContactPersonPhoneNumber"
            value={formData.clientContactPersonPhoneNumber}
            onChange={handleChange}
            error={!!errors.clientContactPersonPhoneNumber}
            helperText={errors.clientContactPersonPhoneNumber}
          />
        <IconButton onClick={handleAddPhoneNumberCompanyField} style={{ marginLeft: '5px' }} color="primary">
            {extraPhoneNumberCompanyVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
        </IconButton>
        </div>

        {extraPhoneNumberCompanyVisible && (
          <div className={classes.detail}>
            {/* <PhoneIphoneIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Alternative Contact Number"
            
              InputLabelProps={{ shrink: true }}
              name="clientContactPersonPhoneNumber1"
              value={formData.clientContactPersonPhoneNumber1}
              onChange={handleChange}
              error={!!errors.clientContactPersonPhoneNumber1}
              helperText={errors.clientContactPersonPhoneNumber1}
            />
          </div>
        )}

        <div className={classes.detail}>
          {/* <Email className={classes.icon} /> */}
          <TextField
          sx={{marginLeft:'42px'}}
            className={classes.textField}
            label="Email"
            name="clientContactPersonEmailId"
            InputLabelProps={{ shrink: true }}
            value={formData.clientContactPersonEmailId}
            onChange={handleChange}
            error={!!errors.clientContactPersonEmailId}
            helperText={errors.clientContactPersonEmailId}
          />
           <IconButton onClick={handleAddEmailCompanyField} style={{ marginLeft: '5px' }} color="primary">
            {extraEmailCompanyVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
          </IconButton> 
        </div>

        {extraEmailCompanyVisible && (
          <div className={classes.detail}>
            {/* <MailOutlineIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Alternative Email"
              name="clientContactPersonEmailId1"
              InputLabelProps={{ shrink: true }}
              value={formData.clientContactPersonEmailId1}
              onChange={handleChange}
              error={!!errors.clientContactPersonEmailId1}
              helperText={errors.clientContactPersonEmailId1}
            />
          </div>
        )}

       

        <div className={classes.detail}>
          {/* <DateRange className={classes.icon} /> */}
          <TextField
         
            className={classes.textField}
            label="Contract Start Date"
            type="date"
            name="startDate"
            
            value={formData.startDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputProps: {
                max: formData.endDate, // Dynamically set the min date
              },
            }}
            error={!!errors.startDate}
            helperText={errors.startDate}
          />
        </div>

        <div className={classes.detail}>
          {/* <DateRange className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Contract End Date"
            type="date"
            name="endDate"
            value={formData.endDate}
          
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputProps: {
                min: formData.startDate, // Dynamically set the min date
              },
            }}
            error={!!errors.endDate}
            helperText={errors.endDate}
          />
        </div>

        <div className={classes.detail}>
          {/* <AccountCircle className={classes.icon} /> */}
          <TextField
            className={classes.textField}
            label="Username"
            name="clientUsername"
            InputLabelProps={{ shrink: true }}
            value={formData.clientUsername}
            onChange={handleChange}
            error={!!errors.clientUsername}
            helperText={errors.clientUsername}
            autoComplete="off" 
          />
        </div>

        <div className={classes.detail}>
          {/* <Lock className={classes.icon} /> */}
          <FormControl sx={{ width: '100%' }} >
            <TextField
            sx={{marginLeft:'10%'}}
              className={classes.textField}
              id="outlined-adornment-password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff sx={{color:'black'}}/> : <Visibility sx={{color:'black'}} />}
                    </IconButton>
                    <Tooltip title="Generate Password">
                                           <IconButton
                                           aria-label="generate password"
                                           onClick={handleGeneratePassword}
                                          edge="end"
                                        >
                                          <Autorenew sx={{ color: 'grey' }} />
                                       </IconButton>
                                       </Tooltip>
                  </InputAdornment>
                ),
              }}
              label="Password"
              name="clientPassword"
              value={formData.clientPassword}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.clientPassword}
              helperText={errors.clientPassword}
              autoComplete="off" 
            />
          </FormControl>
        </div>
      </Grid>
      <Grid item xs={12}>
    <button type="button" className="btn  btn-success float-end   mt-2 mb-2" style={{marginRight:'59px'}} onClick={handleSave}>
        Create
      </button>
    </Grid>
    </Grid>

   
 
  </div>




    </div>
    </>
  );
};

export default CompanyCard;

